/* LUMYRA — JS propio (vanilla). Cada init comprueba que su elemento exista. */
(function () {
  window.__mtReady = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Reveals con un solo IntersectionObserver ---- */
  var io = null;
  function initReveal() {
    var els = document.querySelectorAll('.mt-reveal:not([data-mt-o]), .mt-split:not([data-mt-o]), .mt-pasos__line:not([data-mt-o])');
    if (!els.length) return;
    if (!('IntersectionObserver' in window) || reduce) {
      els.forEach(function (e) { e.classList.add('mt-visible'); });
      return;
    }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add('mt-visible'); io.unobserve(en.target); }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    }
    els.forEach(function (e) {
      e.setAttribute('data-mt-o', '1');
      if (window.Shopify && Shopify.designMode) { e.classList.add('mt-visible'); return; }
      io.observe(e);
    });
  }

  /* ---- Titulares por líneas (separados con | en el ajuste) ---- */
  function initSplit() {
    document.querySelectorAll('.mt-split:not([data-mt-s])').forEach(function (h) {
      h.setAttribute('data-mt-s', '1');
      var lines = (h.getAttribute('data-lines') || h.innerHTML).split('|');
      h.innerHTML = lines.map(function (l, i) {
        return '<span class="mt-line" style="--l:' + i + '"><span>' + l.trim() + '</span></span>';
      }).join('');
    });
  }

  /* ---- Parallax suave (solo transform) ---- */
  var pxEls = [];
  function initParallax() {
    pxEls = Array.prototype.slice.call(document.querySelectorAll('[data-mt-parallax]'));
    if (!pxEls.length || reduce) return;
    var ticking = false;
    function upd() {
      var vh = window.innerHeight;
      pxEls.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.bottom < -100 || r.top > vh + 100) return;
        var k = parseFloat(el.getAttribute('data-mt-parallax')) || 0.08;
        el.style.setProperty('--mt-py', ((r.top + r.height / 2 - vh / 2) * -k).toFixed(1));
      });
      ticking = false;
    }
    if (!window.__mtPx) {
      window.__mtPx = true;
      window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(upd); } }, { passive: true });
      window.addEventListener('resize', upd);
    }
    upd();
  }

  /* ---- Marquesinas: duplicar contenido para bucle infinito ---- */
  function initMarquee() {
    document.querySelectorAll('[data-mt-marquee]:not([data-mt-m])').forEach(function (t) {
      t.setAttribute('data-mt-m', '1');
      t.innerHTML = t.innerHTML + t.innerHTML;
    });
  }

  /* ---- Selector de luces (sección colores) ---- */
  function initLuz() {
    document.querySelectorAll('.mt-luz:not([data-mt-l])').forEach(function (root) {
      root.setAttribute('data-mt-l', '1');
      var items = root.querySelectorAll('.mt-luz__item');
      var img = root.querySelector('.mt-luz__img');
      if (!items.length) return;
      function set(it) {
        items.forEach(function (x) { x.classList.toggle('is-active', x === it); x.setAttribute('aria-expanded', x === it ? 'true' : 'false'); });
        root.style.setProperty('--mt-c', it.getAttribute('data-color'));
        var src = it.getAttribute('data-img');
        if (img && src && img.getAttribute('data-cur') !== src) {
          img.setAttribute('data-cur', src);
          img.style.opacity = 0;
          setTimeout(function () { img.src = src; img.alt = it.getAttribute('data-alt') || ''; img.style.opacity = 1; }, 280);
        }
      }
      items.forEach(function (it) { it.addEventListener('click', function () { set(it); }); it.addEventListener('mouseenter', function () { if (window.matchMedia('(hover:hover)').matches) set(it); }); });
      set(items[0]);
      var i = 0, timer = null;
      function auto() { timer = setInterval(function () { i = (i + 1) % items.length; set(items[i]); }, 3800); }
      if (!reduce) {
        root.addEventListener('mouseenter', function () { clearInterval(timer); });
        root.addEventListener('mouseleave', auto);
        if (!(window.Shopify && Shopify.designMode)) auto();
      }
    });
  }

  /* ---- Producto: galería, variantes, cantidad, barra fija ---- */
  function initProducto() {
    document.querySelectorAll('.mt-prod:not([data-mt-p])').forEach(function (root) {
      root.setAttribute('data-mt-p', '1');
      var main = root.querySelector('.mt-gal__main');
      var mainImg = main && main.querySelector('img');
      var thumbs = root.querySelectorAll('.mt-gal__thumb');
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () {
          thumbs.forEach(function (x) { x.classList.remove('is-active'); });
          t.classList.add('is-active');
          mainImg.style.opacity = 0;
          setTimeout(function () { mainImg.src = t.getAttribute('data-src'); mainImg.alt = t.getAttribute('data-alt') || ''; mainImg.style.opacity = 1; }, 200);
        });
      });
      if (main && window.matchMedia('(hover:hover)').matches) {
        main.addEventListener('mouseenter', function () { main.classList.add('is-zoom'); });
        main.addEventListener('mouseleave', function () { main.classList.remove('is-zoom'); });
        main.addEventListener('mousemove', function (e) {
          var r = main.getBoundingClientRect();
          main.style.setProperty('--zx', ((e.clientX - r.left) / r.width * 100) + '%');
          main.style.setProperty('--zy', ((e.clientY - r.top) / r.height * 100) + '%');
        });
      }
      /* variantes */
      var jsonEl = root.querySelector('[data-mt-variants]');
      var form = root.querySelector('form[data-mt-form]');
      if (jsonEl && form) {
        var variants = JSON.parse(jsonEl.textContent);
        var idInput = form.querySelector('input[name=id]');
        var btn = form.querySelector('[data-mt-add]');
        var priceEls = root.querySelectorAll('[data-mt-price]');
        var compareEl = root.querySelector('[data-mt-compare]');
        var lbl = btn ? btn.getAttribute('data-label') : '';
        var soldLbl = btn ? btn.getAttribute('data-sold') : '';
        function update() {
          var sel = [];
          form.querySelectorAll('.mt-opt').forEach(function (f) { var c = f.querySelector('input:checked'); sel.push(c ? c.value : null); });
          var v = variants.find(function (x) { return x.options.every(function (o, i) { return sel[i] === null || o === sel[i]; }); });
          if (!v) { btn.disabled = true; btn.querySelector('span').textContent = soldLbl; return; }
          idInput.value = v.id;
          priceEls.forEach(function (p) { p.textContent = v.price_fmt; });
          if (compareEl) { compareEl.textContent = v.compare_fmt || ''; compareEl.style.display = v.compare_fmt ? '' : 'none'; }
          btn.disabled = !v.available;
          btn.querySelector('span').textContent = v.available ? lbl : soldLbl;
          if (history.replaceState) history.replaceState(null, '', '?variant=' + v.id);
        }
        form.querySelectorAll('.mt-opt input').forEach(function (i) { i.addEventListener('change', update); });
      }
      var q = root.querySelector('.mt-qty');
      if (q) {
        var inp = q.querySelector('input');
        q.querySelector('[data-dec]').addEventListener('click', function () { inp.value = Math.max(1, (+inp.value || 1) - 1); });
        q.querySelector('[data-inc]').addEventListener('click', function () { inp.value = Math.min(99, (+inp.value || 1) + 1); });
      }
      /* barra fija móvil */
      var bar = document.querySelector('.mt-sticky-buy');
      var addBtn = root.querySelector('[data-mt-add]');
      if (bar && addBtn && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (es) { bar.classList.toggle('is-on', !es[0].isIntersecting && es[0].boundingClientRect.top < 0); }).observe(addBtn);
        var go = bar.querySelector('button, a');
        if (go) go.addEventListener('click', function (e) { e.preventDefault(); addBtn.scrollIntoView({ behavior: 'smooth', block: 'center' }); });
      }
    });
  }

  /* ---- Acordeones: cerrar los demás (FAQ) ---- */
  function initFaq() {
    document.querySelectorAll('.mt-faq__list:not([data-mt-f])').forEach(function (l) {
      l.setAttribute('data-mt-f', '1');
      l.addEventListener('toggle', function (e) {
        if (!e.target.open) return;
        l.querySelectorAll('details[open]').forEach(function (d) { if (d !== e.target) d.open = false; });
      }, true);
    });
  }

  /* ---- Contador de oferta ---- */
  function initCountdown() {
    document.querySelectorAll('[data-mt-countdown]:not([data-mt-cd-init])').forEach(function (el) {
      el.setAttribute('data-mt-cd-init', '1');
      var end = new Date(el.getAttribute('data-end')).getTime();
      if (isNaN(end)) return;
      var dEl = el.querySelector('[data-mt-d]'), hEl = el.querySelector('[data-mt-h]'),
          mEl = el.querySelector('[data-mt-m]'), sEl = el.querySelector('[data-mt-s]');
      function tick() {
        var diff = end - Date.now();
        if (diff <= 0) { el.classList.add('is-ended'); clearInterval(timer); return; }
        var d = Math.floor(diff / 86400000);
        var h = Math.floor((diff % 86400000) / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        var s = Math.floor((diff % 60000) / 1000);
        var p2 = function (n) { return String(n).padStart(2, '0'); };
        if (dEl) dEl.textContent = p2(d);
        if (hEl) hEl.textContent = p2(h);
        if (mEl) mEl.textContent = p2(m);
        if (sEl) sEl.textContent = p2(s);
      }
      tick();
      var timer = setInterval(tick, 1000);
    });
  }

  /* ---- Comparador apagada/encendida ---- */
  function initCmp() {
    document.querySelectorAll('[data-mt-cmp]:not([data-mt-c])').forEach(function (el) {
      el.setAttribute('data-mt-c', '1');
      var r = el.querySelector('.mt-cmp__range');
      function set(v) { el.style.setProperty('--pos', v + '%'); }
      r.addEventListener('input', function () { set(r.value); });
      if (!reduce && 'IntersectionObserver' in window && !(window.Shopify && Shopify.designMode)) {
        var done = false;
        new IntersectionObserver(function (es, o) {
          if (!es[0].isIntersecting || done) return; done = true; o.disconnect();
          var t0 = null, from = +r.value;
          function step(t) { t0 = t0 || t; var k = Math.min((t - t0) / 1800, 1); var e = Math.sin(k * Math.PI * 2) * (1 - k) * 22; set(from + e); r.value = from + e; if (k < 1) requestAnimationFrame(step); else { set(from); r.value = from; } }
          setTimeout(function () { requestAnimationFrame(step); }, 900);
        }, { threshold: 0.6 }).observe(el);
      }
    });
  }
  function init() { initCmp(); initMarquee(); initLuz(); initProducto(); initFaq(); initCountdown(); initParallax(); initReveal(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

